import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const packageTypesSchema: CollectionCreateSchema = {
  name: CollectionName.PackageTypes,
  fields: [
    {
      name: "code",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "plural_label",
      type: "string",
      facet: false,
      optional: true,
      infix: true,
      sort: true,
    },
    {
      name: "description",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "certificate_types",
      type: "string[]",
      infix: true,
      facet: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
